import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Component({
  selector: 'new-password-step',
  templateUrl: './new-password-step.component.html',
  styleUrls: ['./new-password-step.component.scss'],
})
export class NewPasswordStepComponent {
  public passwordMatches: any[];

  @Input()
  public title: string;

  @Input()
  public isLoading: boolean;

  @Input()
  public description: string;

  @Input()
  public disabled: boolean;

  @Input()
  public resetPasswordForm: FormGroup;

  @Input()
  public verificationCodeForm: FormArray;

  @Output()
  public resetPassword: EventEmitter<void>;

  public showNewPassword = false;
  public showConfirmationPassword = false;

  constructor() {
    this.resetPassword = new EventEmitter<void>();
    this.passwordMatches = [
      { translate: 'CHARACTERS', regex: '^.{8,}$' },
      { translate: 'UPPER_CASE_LETTER', regex: '[A-Z]{1,}' },
      { translate: 'LOWER_CASE_LETTER', regex: '[a-z]{1,}' },
      { translate: 'ONE_DIGIT', regex: '[0-9]{1,}' },
      { translate: 'ONE_SPECIAL_CHARACTER', regex: '[^a-zA-Z0-9]{1,}' }
    ];
  }

  public matchValue(regex: string, value: string | null): boolean {
    if (!value) {
      return false;
    }

    return RegExp(regex).test(value);
  }
}
